import React from 'react';
import { useField } from 'formik';
import { useEffect } from 'react';
import SpecialInstructions from './SpecialInstructions';
import { Switch } from '@headlessui/react';
import classNames from '../../../utility/classNames';
import Tooltip from '../../Tooltip';

export default function Toggle({
  name,
  label,
  description,
  specialInstructions,
  ...props
}) {
  // eslint-disable-next-line no-unused-vars
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const style = props.layout || 'default';
  return (
    <>
      {specialInstructions && (
        <SpecialInstructions
          instructions={specialInstructions}
          name={name}
          label=" "
        />
      )}

      <Switch.Group as="div" className="flex items-center justify-between">
        <span className="flex-grow flex flex-col">
          <Switch.Label
            as="span"
            className={classNames(
              'text-md text-neutral-900 pr-2',
              style === 'tableNoLabel' && 'sm:hidden'
            )}
            passive
          >
            {label}
            {description && (
              <>
                {' '}
                <Tooltip text={description} type="info" />
              </>
            )}
          </Switch.Label>
          {/* <Switch.Description as="span" className="text-sm text-neutral-500">
            {description}
          </Switch.Description> */}
        </span>
        <Switch
          checked={field.value}
          onChange={() => setValue(!field.value)}
          className={classNames(
            field.value
              ? 'bg-primary-500 border-primary-600'
              : 'bg-neutral-200 border-neutral-300',
            'relative inline-flex flex-shrink-0 h-8 w-14 border-2  rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
          )}
        >
          <span
            aria-hidden="true"
            className={classNames(
              field.value ? 'translate-x-6' : 'translate-x-0',
              'pointer-events-none inline-block h-[24px] w-[24px] mt-[2px] mx-[2px] rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200'
            )}
          />
        </Switch>
      </Switch.Group>
    </>
  );
}
